module.exports = require("core-js/library/fn/object/entries");


//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/@babel/runtime/core-js/object/entries.js
// module id = 172
// module chunks = 35783957827783 114276838955818